import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
import Message from '../../config/message_v2.js';

export default {
  ValidateForm(form){
    if(form.method === 'email') {
      if(!form.email){
        toast.warning(Message.ERROR.EMPTY.EMAIL)
        return false
      } else if(!form.time){
        toast.warning(Message.ERROR.EMPTY.REMAINDER_TIME)
        return false
      } 

    } else if(form.method === 'mobile') {
      if(!form.mobile){
        toast.warning(Message.ERROR.EMPTY.PHONE_NUMBER)
        return false
      } else if(!form.time){
        toast.warning(Message.ERROR.EMPTY.REMAINDER_TIME)
        return false
      } 

    } else {
      if(!form.email){
        toast.warning(Message.ERROR.EMPTY.EMAIL)
        return false
      } else if(!form.mobile){
        toast.warning(Message.ERROR.EMPTY.PHONE_NUMBER)
        return false
      }  
      else if(!form.time){
        toast.warning(Message.ERROR.EMPTY.REMAINDER_TIME)
        return false
      } 
    }

    return true
  },
}


// WEBPACK FOOTER //
// ./src/App/remainder/helper/form.js